import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { getProductView_productDetailByMasterId } from '../queries/__generated__/getProductView';

import { messages } from './messages';
import {
  ForbiddenProductScreenWrapper,
  Collection,
  Brand,
  ForbiddenInfoWrapper,
  TitleWrapper,
  ViewPort,
} from './styled';

interface IForbiddenProductScreenProps {
  product: getProductView_productDetailByMasterId;
}

export const ForbiddenProductScreen: React.FC<IForbiddenProductScreenProps> = ({
  product,
}) => (
  <ViewPort>
    <ForbiddenProductScreenWrapper>
      <TitleWrapper>
        <Brand>{product.brand}</Brand>
        <Collection>{product.collection}</Collection>
      </TitleWrapper>
      <ForbiddenInfoWrapper>
        <FormattedMessage {...messages.forbiddenDescription} />
      </ForbiddenInfoWrapper>
    </ForbiddenProductScreenWrapper>
  </ViewPort>
);
